import type { CSSProperties, ReactNode } from 'react';
import {
  AlertTriangle,
  GraduationCap,
  Heart,
  Users,
  MessageSquare,
  Award,
  HelpCircle,
} from 'lucide-react';
import type { CategoriaObservacao, NivelAtencao } from '../../api/hooks/useObservacoes';

export const CATEGORIA_CONFIG: Record<
  CategoriaObservacao,
  { label: string; icon: ReactNode; color: string; bg: string }
> = {
  COMPORTAMENTO: {
    label: 'Comportamento',
    icon: <AlertTriangle size={14} />,
    color: '#dc2626',
    bg: 'rgba(220,38,38,0.1)',
  },
  APRENDIZAGEM: {
    label: 'Aprendizagem',
    icon: <GraduationCap size={14} />,
    color: '#2563eb',
    bg: 'rgba(37,99,235,0.1)',
  },
  SAUDE: {
    label: 'Saude',
    icon: <Heart size={14} />,
    color: '#059669',
    bg: 'rgba(5,150,105,0.1)',
  },
  SOCIAL: {
    label: 'Social',
    icon: <Users size={14} />,
    color: '#7c3aed',
    bg: 'rgba(124,58,237,0.1)',
  },
  FAMILIAR: {
    label: 'Familiar',
    icon: <MessageSquare size={14} />,
    color: '#d97706',
    bg: 'rgba(217,119,6,0.1)',
  },
  ELOGIO: {
    label: 'Elogio',
    icon: <Award size={14} />,
    color: '#0891b2',
    bg: 'rgba(8,145,178,0.1)',
  },
  OUTRO: {
    label: 'Outro',
    icon: <HelpCircle size={14} />,
    color: '#6b7280',
    bg: 'rgba(107,114,128,0.1)',
  },
};

export const NIVEL_CONFIG: Record<NivelAtencao, { label: string; color: string; bg: string }> = {
  INFORMATIVO: { label: 'Informativo', color: '#6b7280', bg: 'rgba(107,114,128,0.1)' },
  ATENCAO: { label: 'Atencao', color: '#d97706', bg: 'rgba(217,119,6,0.1)' },
  URGENTE: { label: 'Urgente', color: '#dc2626', bg: 'rgba(220,38,38,0.1)' },
};

export const CATEGORIAS_RESTRITAS: CategoriaObservacao[] = ['SAUDE', 'FAMILIAR', 'SOCIAL'];
export const CATEGORIAS_SIGILOSAS: CategoriaObservacao[] = ['SAUDE', 'FAMILIAR'];
export const PERFIS_ACESSO_TOTAL = ['ADMIN', 'ESCOLA'];

export const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: '0.75rem',
  fontWeight: 600,
  color: 'var(--text-muted, #555)',
  marginBottom: 4,
};

export const inputStyle: CSSProperties = {
  width: '100%',
  padding: '8px 12px',
  borderRadius: 8,
  border: '1px solid var(--border-color, #d1d5db)',
  background: 'var(--bg-card, #fff)',
  color: 'var(--text-main, #111)',
  fontSize: '0.85rem',
  fontFamily: 'inherit',
};

export const btnPrimary: CSSProperties = {
  padding: '8px 16px',
  borderRadius: 10,
  border: 'none',
  background: 'linear-gradient(135deg, #065f46, #059669)',
  color: '#fff',
  fontSize: '0.78rem',
  fontWeight: 700,
  cursor: 'pointer',
};

export const btnSecondary: CSSProperties = {
  padding: '8px 16px',
  borderRadius: 10,
  border: '1px solid var(--border-color, #d1d5db)',
  background: 'transparent',
  color: 'var(--text-muted, #666)',
  fontSize: '0.78rem',
  fontWeight: 600,
  cursor: 'pointer',
};
